<template>
  <div>
    <modal :visible.sync="isShowDialog" :title="$t('integration.rule')"  width="1000px" @close="close">
      <div class="uk-flex h-100" style="height: 645px;">
        <!-- 左边 -->
        <div class="border reflect-box">
          <!-- 规则list -->
          <div>
            <div class="pd-5 bd-b uk-flex uk-text-center">
              <el-input v-model="searchRuleName"
                :placeholder="$t('integration.enter_rule_name')" style="width:80%"
                clearable>
              </el-input>
              <el-button type="primary" icon="el-icon-search" style="margin-right:0;" @click="getListFn"></el-button>
            </div>
            <div style='overflow-y: auto;height: 300px;'>
              <template v-if="ruleList.length">
                <div class="uk-flex border uk-text-center reflect-item "  v-for="(rule, index) in ruleList"
                    :key="rule.id">
                    <div class="uk-flex-1 cursor-pointer" :class="{ active: currentRule.id === rule.id }"
                        @click="changeRule(rule)">{{ rule.name }}</div>
                    <div class="bd-l" style="width: 30px;">
                        <i class="el-icon-delete cursor-pointer" @click="deleteRule(rule, index)"></i>
                    </div>
                </div>
              </template>
              <el-empty v-else :description="$t('public.no_data')"></el-empty>
            </div>
            <el-button type="primary" style="width: 100%;" @click="addRule">
              <i class="el-icon-plus" style="color: #fff"></i>
            </el-button>
          </div>
          <!-- 监测点list -->
          <div>
            <div class="pd-5 bd-b uk-flex uk-text-center">
              <el-input v-model="searchCarrierName"
                :placeholder="$t('home.please_enter_carrier')" style="width:80%"
                clearable>
              </el-input>
              <el-button type="primary" icon="el-icon-search" style="margin-right:0;" @click="getCarrierListFn"></el-button>
            </div>
            <div style='overflow-y: auto;height: 200px;'>
                <div class="uk-flex border uk-text-center reflect-item "  v-for="(carrier, index) in carrierList"
                    :key="carrier.carrierId">
                    <div class="uk-flex-1 cursor-pointer bg-theme color-white" @click="toCarrierDetail(carrier)">
                      {{ carrier.carrierName }}
                    </div>
                    <div class="bd-l" style="width: 30px;">
                        <i class="el-icon-delete cursor-pointer" @click="deleteCarrier(carrier.carrierId)"></i>
                    </div>
                </div>
            </div>
            <el-button type="primary" style="width: 100%;"
              :disabled="isFirstAdd"
               @click="isShowCarrierDialog = true">
              <i class="el-icon-plus" style="color: #fff"></i>
            </el-button>
          </div>

      </div>
      <!-- 右边 -->
      <div class="uk-flex-1 border-box bd-r bd-t h-100 bd-l"
        style="position: relative;">
        <el-form class="h-100" v-if="currentRule.id">
          <div class="pd-5 bd-b right-header">
            <el-form-item >
                <div class="w-100 uk-flex uk-flex-middle uk-flex-between">
                    <el-input v-model="currentRule.name" placeholder="" style="width: 250px;"
                        maxlength="20"></el-input>
                    <div>
                      <el-button type="primary" circle @click="isShowRuleDialog = true">
                        <i class="el-icon-plus" style="color: #fff"></i>
                      </el-button>
                      <el-button type="primary" @click="handleSave">{{ $t('integration.preservation') }}</el-button>
                    </div>

                </div>
            </el-form-item>
          </div>
          <div class="rule-div" v-if="currentRule.rule && Object.keys(currentRule.rule).length">
            <!-- 大规则 -->
            <div v-for="(item, key) in currentRule.rule" :key="key" class="border mb-10">
              <div class="uk-flex uk-flex-between uk-flex-middle bd-b pd-10">
                <span>{{ $t(ruleTypesConvert(key).title)}}</span>
                <div>
                  <el-button type="primary" @click="addRuleItem(key)" :disabled="disabledFn(item, key)">
                    <i class="el-icon-plus" style="color: #fff"></i>
                  </el-button>
                  <el-button type="primary" @click="addGroup(key)" :disabled="disabledFn(item, key)">
                    <i class="el-icon-plus" style="color: #fff"></i>Group
                  </el-button>
                    <i class="el-icon-circle-close color-red mr-5 cursor-pointer" style="font-size: 20px;"
                    @click="delRuleList(key)"></i>
                </div>
              </div>
              <!-- 大规则里面的规则list -->
              <div class="pd-10">
                <div v-for="(item2, index2) in item" :key="index2">
                <el-divider content-position="left" v-if="item2.logic !== 0">
                    <el-tag :type="item2.logic === 1 ? 'info': ''"
                      class="cursor-pointer"
                      @click="item2.logic = 1">And</el-tag>
                    <el-tag :type="item2.logic === 2 ? 'info': ''"
                      class="ml-5 cursor-pointer"
                      @click="item2.logic = 2">Or</el-tag>
                  </el-divider>
                  <!-- 是group时 -->
                  <div v-if="item2.isGroup" class="border mb-10">
                    <div class="uk-flex uk-flex-between uk-flex-middle bd-b pd-10">
                      <span>{{ item2.name }}</span>
                      <div>
                        <el-button type="primary" @click="addRuleGroupItem(item2)" :disabled="disabledFn(item, key)">
                          <i class="el-icon-plus" style="color: #fff"></i>
                        </el-button>
                          <i class="el-icon-circle-close color-red mr-5 cursor-pointer" style="font-size: 20px;"
                          @click="delRuleItem(key, index2)"></i>
                      </div>
                    </div>
                    <div class="pd-10" v-for="(glist,gindex) in item2.ruleList" :key="gindex">
                      <el-divider content-position="left" v-if="glist.logic !== 0">
                        <el-tag :type="glist.logic === 1 ? 'info': ''"
                          class="cursor-pointer"
                          @click="glist.logic = 1">And</el-tag>
                        <el-tag :type="glist.logic === 2 ? 'info': ''"
                        class="ml-5 cursor-pointer"
                        @click="glist.logic = 2">Or</el-tag>
                      </el-divider>
                      <div class="uk-flex  uk-flex-middle border">
                        <el-select v-model="glist.type" style="width: 180px;" class="bd-r pd-10">
                            <el-option v-for="(item, key2) in ruleItemType(key)" :key="key2" :label="$t(item.title)"
                                :value="parseInt(key2)"></el-option>
                        </el-select>
                        <div class="uk-flex-1 ml-5 pl-5">
                          <!-- 数值容错 -->
                          <template v-if="glist.type === 1">
                            {{ $t('public.upper_limit')}} +
                            <el-input v-model="glist.max" placeholder="" style="width: 70px;"
                              oninput="value=value.match(/\d+\.?\d{0,2}/, '')"  @blur="changeNumber(glist, 'max')">
                            </el-input>
                            {{ $t('public.lower_limit')}} -
                            <el-input v-model="glist.min" placeholder="" style="width: 70px;"
                              oninput="value=value.match(/\d+\.?\d{0,2}/, '')" @blur="changeNumber(glist, 'min')">
                            </el-input>
                          </template>
                          <!-- 时间容错 -->
                          <template v-if="glist.type === 2">
                            {{ $t('public.fault_duration_less')}}
                            <el-input v-model.number="glist.num" placeholder="" style="width: 70px;"
                               oninput="value=value.replace(/[^\d.]/g, '')"></el-input>
                            {{$t('public.minute')}}
                          </template>
                          <!-- 连续性异常 -->
                          <template v-if="glist.type === 3">
                            {{ $t('public.continuous_anomal_less')}}
                            <el-input v-model.number="glist.num" placeholder="" style="width: 70px;"
                               oninput="value=value.replace(/[^\d.]/g, '')"></el-input>
                            {{ $t('public.times')}}
                          </template>
                          <!-- 异常频率 -->
                          <template v-if="glist.type === 4">
                            {{ $t('public.abnormal_frequency_less')}}
                            <el-input v-model.number="glist.num" placeholder="" style="width: 70px;"
                               oninput="value=value.replace(/[^\d.]/g, '')"></el-input>
                            {{ $t('public.times')}}
                          </template>
                          <!-- 重连时长 -->
                          <template v-if="glist.type === 5">
                            {{ $t('public.reconnection_duration_less')}}
                            <el-input v-model.number="glist.num" placeholder="" style="width: 70px;"
                               oninput="value=value.replace(/[^\d.]/g, '')"></el-input>
                            {{ $t('public.minute')}}
                          </template>
                          <!-- 断电时长 -->
                          <template v-if="glist.type === 6">
                            {{ $t('public.Power_duration_less')}}
                            <el-input v-model.number="glist.num"  placeholder="" style="width: 70px;"
                               oninput="value=value.replace(/[^\d.]/g, '')"></el-input>
                            {{ $t('public.minute')}}
                          </template>

                        </div>
                        <!-- 如果group里面只有一个rule,小规则就没有删除，要删就把整个group删掉 -->
                        <i v-if="item2.ruleList.length > 1"
                          class="el-icon-circle-close color-red mr-5" style="font-size: 20px;"
                          @click="delRuleGroupItem(item2, gindex)"></i>
                      </div>
                    </div>
                  </div>
                  <div v-else class="mb-10">
                    <div class="uk-flex  uk-flex-middle border">
                      <el-select v-model="item2.type" style="width: 180px;" class="bd-r pd-10">
                          <el-option v-for="(item, key2) in ruleItemType(key)" :key="key2" :label="$t(item.title)"
                              :value="parseInt(key2)"></el-option>
                      </el-select>
                      <div class="uk-flex-1 ml-5 pl-5">
                        <!-- 数值容错 -->
                        <template v-if="item2.type === 1">
                          {{ $t('public.upper_limit')}} +
                          <el-input v-model="item2.max" placeholder="" style="width: 70px;"
                            oninput="value=value.match(/\d+\.?\d{0,2}/, '')" @blur="changeNumber(item2, 'max')"
                             >
                            </el-input>
                          {{ $t('public.lower_limit')}} -
                          <el-input v-model="item2.min" placeholder="" style="width: 70px;"
                            oninput="value=value.match(/\d+\.?\d{0,2}/, '')"  @blur="changeNumber(item2, 'min')">
                          </el-input>
                        </template>
                        <!-- 时间容错 -->
                        <template v-if="item2.type === 2">
                          {{ $t('public.fault_duration_less')}}
                          <el-input v-model.number="item2.num" placeholder="" style="width: 70px;"
                             oninput="value=value.replace(/[^\d.]/g, '')"></el-input>
                          {{ $t('public.minute')}}
                        </template>
                        <!-- 连续性异常 -->
                        <template v-if="item2.type === 3">
                          {{ $t('public.continuous_anomal_less')}}
                          <el-input v-model.number="item2.num" placeholder="" style="width: 70px;"
                             oninput="value=value.replace(/[^\d.]/g, '')"></el-input>
                          {{ $t('public.times')}}
                        </template>
                        <!-- 异常频率 -->
                        <template v-if="item2.type === 4">
                          {{ $t('public.abnormal_frequency_less')}}
                          <el-input v-model.number="item2.num" placeholder="" style="width: 70px;"
                             oninput="value=value.replace(/[^\d.]/g, '')"></el-input>
                          {{ $t('public.times')}}
                        </template>
                        <!-- 重连时长 -->
                        <template v-if="item2.type === 5">
                          {{ $t('public.reconnection_duration_less')}}
                          <el-input v-model.number="item2.num" placeholder="" style="width: 70px;"
                             oninput="value=value.replace(/[^\d.]/g, '')"></el-input>
                          {{ $t('public.minute')}}
                        </template>
                        <!-- 断电时长 -->
                        <template v-if="item2.type === 6">
                          {{ $t('public.Power_duration_less')}}
                          <el-input v-model.number="item2.num"  placeholder="" style="width: 70px;"
                             oninput="value=value.replace(/[^\d.]/g, '')"></el-input>
                          {{ $t('public.minute')}}
                        </template>

                      </div>
                      <i class="el-icon-circle-close color-red mr-5 cursor-pointer" style="font-size: 20px;"
                        @click="delRuleItem(key, index2)"></i>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div v-else class="h-100">
            <span class="empty text-middle">{{ $t('integration.please_add_rule') }}</span>
          </div>

        </el-form>

        <div v-else class="h-100">
          <el-empty :description="$t('public.no_data')"></el-empty>
        </div>
      </div>


      </div>




    </modal>

    <!-- 新增规则dialog -->
    <modal :visible.sync="isShowRuleDialog" :title="$t('integration.add_rule_title')"  width="400px">
      <el-form label-width="80px" class="add-rule-form">
        <el-form-item :label="$t('integration.rule')">
          <el-select v-model="ruleType" @change="ruleTypeChange">
              <el-option v-for="(item, key) in ruleTypes" :key="key" :label="$t(item.title)"
                  :value="key"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="isShowRuleDialog = false">{{ $t('public.btn_cancel') }}</el-button>
        <el-button type="primary" @click="handleAddRule">{{ $t('public.btn_ok') }}</el-button>
      </div>

    </modal>


    <!-- 监测点选择dialog -->
    <CarrierDialog
      v-if="isShowCarrierDialog"
      :isShow="isShowCarrierDialog"
      :ruleId="currentRule.id"
      :carrierList="carrierList"
      @close="isShowCarrierDialog = false"
      @updateCarrier="updateCarrier"
     />


  </div>
</template>
<script>
import { getRuleList, getRuleDetail, getRuleCarrierList, saveRule, updateRule, ruleDel, ruleCarrierDel } from '@/api/modules/abnormal.js'
import {ruleTypes, ruleTypesConvert, ruleItemType} from '@/utils/convert.js'
import CarrierDialog from './component/CarrierDialog.vue'
import { carrierDetail } from '@/utils/winDetail'

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
  },
  components: {
    CarrierDialog
  },
  data(){
    return {
      searchRuleName: null,
      searchCarrierName: null,
      ruleList: [],
      currentRule: {}, // 当前编辑的规则

      isShowRuleDialog: false,
      ruleType: 'tempRule',

      addRuleList: [],
      rule: {
        // tempRule: [],
        // humRule: [],
        // offlineRule: [],
        // powerOffRule: [],

      },


      ruleTypes,
      ruleTypesConvert,
      ruleItemType,

      carrierList: [], // 监测点list

      isShowCarrierDialog: false,



    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    // 区别初次新增安装点还是编辑
    isFirstAdd(){
      return this.currentRule.id === 'adding'
    }
  },
  async mounted(){
    await this.getListFn()
    // 默认一开始选中第一个
    console.log('是不是在后面')
    if (this.ruleList.length && !this.currentRule.id) {
      this.changeRule(this.ruleList[0])
    }
  },
  methods: {
    close(){
      this.type = null
      this.$emit('close')
    },
    // 获取rule
    getListFn(){
      console.log('getListFn-----------------')
      return new Promise(resolve => {
        getRuleList({name: this.searchRuleName}).then(res => {
          if (res.state.code === 200) {
            this.ruleList = res.result
          }
          resolve()
        })
      })

    },
    // 获取该rule下监测点list
    getRuleCarrier(id){
      getRuleCarrierList(id, {carrierName: this.searchCarrierName}).then(res => {
         if (res.state.code === 200) {
            this.carrierList = res.result
          }
      })
    },
    changeRule(rule){
      if (this.isFirstAdd) {
        return this.$message.warning($t('integration.currently_adding_c__please_save_or_delete_and_try_again'))
      }
      // this.currentRule = JSON.parse(JSON.stringify(rule))
      // this.searchCarrierName = null
      this.getRuleInfo(rule.id)
      this.getRuleCarrier(rule.id)

    },
    // 搜索监测点
    getCarrierListFn(){
      this.getRuleCarrier(this.currentRule.id)
    },
    //  删除无效异常规则关联的监测点
    deleteCarrier(carrierId){
      this.$confirm($t('integration.are_you_sure_you_want_to_delete_this_item')).then(() => {
        ruleCarrierDel(this.currentRule.id, carrierId).then(res => {
          if (res.state.code === 200) {
            this.$message.success($t('integration.success'))
            this.getRuleCarrier(this.currentRule.id)

          }
        })
      })

    },
    updateCarrier(){
      this.getRuleCarrier(this.currentRule.id)
    },
    // 点击监测点跳到监测点详情页面
    toCarrierDetail(row){
      carrierDetail(row.carrierId, row.carrierName, row.typeId)
    },

    getRuleInfo(id) {
      getRuleDetail(id).then(res => {
        if (res.state.code === 200) {
          const data = res.result

          // 1. 遍历 rule 对象的所有 key
          for (let key in data.rule) {
            // 情况A：如果是数组，先过滤数组内的空元素
            if (Array.isArray(data.rule[key])) {
              data.rule[key] = data.rule[key].filter(item => Boolean(item))

              // 【关键修改】过滤后，如果数组为空（length === 0），删除该 key
              if (data.rule[key].length === 0) {
                delete data.rule[key]
              }
            }
            // 情况B：如果原本就是 null 或 undefined，直接删除该 key
            else if (data.rule[key] == null) {
              delete data.rule[key]
            }
          }

          // 2. 赋值给 Vue 实例
          this.currentRule = data

          // 3. 遍历处理 Group 名称（此时剩下的都是有数据的 key）
          for (let key in this.currentRule.rule) {
            // 再次判断以防万一（虽然上面已经清理过，这里主要是为了遍历安全）
            if (Array.isArray(this.currentRule.rule[key])) {
              let nameIndex = 1
              this.currentRule.rule[key].forEach(item => {
                if (item && item.isGroup) {
                  // 建议加上索引，否则名字都一样
                  item.name = `Group${nameIndex}`
                  nameIndex++
                }
              })
            }
          }
        }
      })
    }

    ,
    addRule(){
      if (this.isFirstAdd) {
        this.$message.warning($t('integration.currently_adding_c__please_save_or_delete_and_try_again'))
        return
      }
      this.ruleList.push({
        // id: new Date().getTime().toString(),
        id: 'adding',
        name: $t('integration.new_name'),
        rule: {}
      })
      this.currentRule = this.ruleList[this.ruleList.length - 1]
      this.carrierList = []

    },
    delRuleList(key){
      // this.addRuleList.splice(index, 1)
      this.$confirm($t('integration.are_you_sure_you_want_to_delete_this_item')).then(() => {
        delete this.currentRule.rule[key]
        this.$forceUpdate()
      })

    },
    deleteRule(rule, index){
      this.$confirm($t('integration.are_you_sure_you_want_to_delete_this_item')).then(() => {
        // 如果是删除正在新增的，不需要调接口
        if(rule.id === 'adding'){
          this.ruleList.splice(index, 1)
          // 重置当前rule
          if (this.ruleList.length) {
            this.currentRule = {}
            this.changeRule(this.ruleList[0])
          } else {
            this.currentRule = {}
          }
        }else{
          ruleDel(rule.id).then(async res => {
            if (res.state.code === 200) {
              this.$message.success($t('integration.success'))
              await this.getListFn()
              if(this.currentRule.id === rule.id){
                if (this.ruleList.length) {
                  this.currentRule = {}
                  this.changeRule(this.ruleList[0])
                } else {
                  this.currentRule = {}
                }
              }
            }
          })
        }

      })
    },
    ruleTypeChange(){

    },
    handleAddRule(){
      console.log('this.ruleType=', this.ruleType)
      // 选中的规则不可二次使用
      // let index = this.addRuleList.findIndex(_ => _.ruleType === this.ruleType)
      // if(index !== -1){
      if(this.currentRule.rule[this.ruleType]){
        this.$message.warning($t('integration.rule_exists'))
        return
      }

      this.$set(this.currentRule.rule, this.ruleType, [])

      // this.addRuleList.push({
      //   ruleType: this.ruleType,
      //   group: [],
      //   ruleList: []
      // })
      this.isShowRuleDialog = false

    },
    // 每个规则添加group
    addGroup(ruleType){
      // let index = this.addRuleList.findIndex(_ => _.ruleType === ruleType)
      // if(this.addRuleList[index].group.length){

      // }else{
      //   this.addRuleList[index].group.push({
      //   logic: 0,
      //   // type: 1,
      //   num: null,
      //   name: 'Group1'
      // })
      // }

      let type = 1
      if(ruleType === 'offlineRule'){
        type = 5
      }
      if(ruleType === 'powerOffRule'){
        type = 6
      }
      let logic = 0
      if( this.currentRule.rule[ruleType].length){
        logic = 1
      }
      // this.currentRule.rule[ruleType].push({
      //   logic: logic,
      //   num: null,
      //   type: type,
      //   isGroup: 1,
      //   name: 'Group1'
      // })

      this.currentRule.rule[ruleType].push({
        logic: logic,
        isGroup: 1,
        name: 'Group',
        ruleList: [
          {
            num: null,
            type: type,
            logic: 0
          }
        ]
      })

    },
    // 每个规则添加规则list
    addRuleItem(ruleType){
      // let index = this.addRuleList.findIndex(_ => _.ruleType === ruleType)
      let type = 1
      if(ruleType === 'offlineRule'){
        type = 5
      }
      if(ruleType === 'powerOffRule'){
        type = 6
      }
      // this.addRuleList[index].ruleList.push({
      //   logic: 1,
      //   type: type,
      //   num: null
      // })

      let logic = 0
      if( this.currentRule.rule[ruleType].length){
        logic = 1
      }
      this.currentRule.rule[ruleType].push({
        logic: logic,
        num: null,
        type: type,
      })
    },
    delRuleItem(key, index2){
      // this.addRuleList[index].ruleList.splice(index2, 1)
      this.$confirm($t('integration.are_you_sure_you_want_to_delete_this_item')).then(() => {
        this.currentRule.rule[key].splice(index2, 1)
        // 如果删除的是第一个那么第二个就会变成第一个，那么logic就要变成0
        if(index2 === 0){
          if(this.currentRule.rule[key].length){
            this.currentRule.rule[key][0].logic = 0
          }
        }
      })
    },
    // group里面添加规则
    addRuleGroupItem(item2){
      item2.ruleList.push({
        type: item2.ruleList[0].type,
        num: null,
        logic: 1
      })
    },
    // 删除group里面的小规则
    delRuleGroupItem(item2, gindex){
      item2.ruleList.splice(gindex, 1)
      // 如果ruleList里面有多个，而且删除的是第一个，那么第二个就会变成第一个，那么logic就要变成0
      if(gindex === 0){
        if(item2.ruleList.length){
          item2.ruleList[0].logic = 0
        }
      }
    },

    handleSave(){
      console.log('this.rule', this.currentRule)
      // 保存时每个大规则里面的规则条件也是只能使用一次，是否有重复的
      this.currentRule.rule
      for(let key in this.currentRule.rule){
        console.log(key)
        let typeArr = []
        this.currentRule.rule[key].forEach(rule => {
          if(rule.isGroup){
            rule.ruleList.forEach(rule2 => {
              typeArr.push(rule2.type)
            })
          }else{
            typeArr.push(rule.type)
          }
        })
        let typeSet = new Set(typeArr)
        if(typeArr.length > typeSet.size){
          this.$message.success($t('public.repeated_rule_conditions_tips'))
          return
        }
      }

      // 判断是新增还是更新
      if(this.isFirstAdd){
        let params = {
          name: this.currentRule.name,
          rule: this.currentRule.rule
        }
        saveRule(params).then(async res => {
          if (res.state.code === 200) {
            this.$message.success($t('integration.success'))
            await this.getListFn()
            this.currentRule.id = 0
            this.changeRule(this.ruleList[this.ruleList.length - 1])
          }
        })
      }else{
        let params = {
          id: this.currentRule.id,
          name: this.currentRule.name,
          rule: this.currentRule.rule
        }
        updateRule(params).then(res => {
          if (res.state.code === 200) {
            this.$message.success($t('integration.success'))
            this.getListFn()
          }
        })
      }


    },
    // 每个大规则里面的规则条件也是只能使用一次
    disabledFn(list, key){
      if (!list || !Array.isArray(list)) {
        return false
      }
      let typeObj = this.ruleItemType(key)
      let limit = Object.keys(typeObj).length
      let ruleTypeCount = 0
      list.forEach(rule => {
        if(rule.isGroup){
          rule.ruleList.forEach(rule2 => {
            ruleTypeCount++
          })
        }else{
          ruleTypeCount++
        }
      })
      if(ruleTypeCount < limit){
        return false
      }else{
        return true
      }
    },

    // 将输入的值改成number类型
    changeNumber(item, maxMin){
      item[maxMin] = Number(item[maxMin])
      // this.$set(item, 'max', Number(item.max))
    }
  }
}
</script>

<style scoped lang="scss">
.reflect-box {
  width: 250px;

  .reflect-item {
    border-radius: 3%;
    line-height: 30px;
    margin: 5px;
  }

  .active {
    background-color: $theme-color;
    color: white;
  }
}
.right-header {
  ::v-deep .el-form-item {
    margin-bottom: 0 !important;
  }
}

.rule-div {
  margin: 10px;
  max-height: 600px;
  overflow: auto;
}

.add-rule-form {
  padding: 10px 20px 0 10px;
}

</style>
